import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import trans_en from 'locales/en.json';
import trans_cs from 'locales/cs.json';
import trans_es from 'locales/es.json';
import trans_sk from 'locales/sk.json';
import trans_fr from 'locales/fr.json';
import trans_de from 'locales/de.json';



import {normalizeTranslations} from "locales/utils";


i18n
    .use(LanguageDetector)
    .init({
        fallbackLng: 'en',
        // lng: 'cs',
        ns: ['translations'],
        defaultNS: 'translations',
        debug: process.env.REACT_APP_DEBUG === "1",
        escapeInterpolation: false,
        interpolation: {
            escapeValue: false, // not needed for react!!
            formatSeparator: ',',
            format: function (value, format, lng) {
                if (format === 'uppercase') return value.toUpperCase();
                return value;
            }
        },
        keySeparator: false, // we use content as keys
        isInitialSSR: false,
        react: {
            wait: true,

        },
        resources: {
            en: {
                translations: normalizeTranslations(trans_en)
            },
            cs: {
                translations: normalizeTranslations(trans_cs)
            },
            es: {
                translations: normalizeTranslations(trans_es)
            },
            fr: {
                translations: normalizeTranslations(trans_fr)
            },
            sk: {
                translations: normalizeTranslations(trans_sk)
            },
            de: {
                translations: normalizeTranslations(trans_de)
            }

        }
    });

export default i18n;




// WEBPACK FOOTER //
// ./src/i18n.js